import { Icon } from "react-migration/components/Icon";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const SummaryError = () => {
  const { t } = useTranslation();
  return (
    <div className="flex px-3 gap-x-2 items-center">
      <Icon size="sm" icon="icon-lt-error-warning-line text-negative-800" />
      <div className="text-negative-800 text-xs">{t("planning.ai.failed")}</div>
    </div>
  );
};
